import { useSelector, shallowEqual } from 'react-redux'
import { useEffect, useRef } from 'react'
import { selectCohortingFlagValue, selectStacFlagsReady } from '../reducers/cohorts'
import { fireCohortingEvent } from '../analytics/v3'
import { selectStateForProtobuf } from '../reducers'
import { selectAnalyticsReady } from '../reducers/analytics'
export const useCohortFlag = (flag) => {
  const hasFired = useRef(false)
  const flagValue = useSelector(selectCohortingFlagValue(flag))
  const state = useSelector(selectStateForProtobuf, shallowEqual)
  const isCohortReady = useSelector(selectStacFlagsReady)
  const isAnalyticsReady = useSelector(selectAnalyticsReady)

  useEffect(() => {
    if (!hasFired.current && isCohortReady && flag && isAnalyticsReady) {
      fireCohortingEvent(flag, state)
      hasFired.current = true
    }
  }, [flag, isCohortReady, isAnalyticsReady])

  return flagValue
}
